import { SyndicateRole } from '@ipreo/muni-shared';
import { Report, AmountTypes } from './report';

export interface ManagerOverviewReport extends Report, AmountTypes {
  amount: number;
  managerType: string;
}

export interface ManagerRetailReport extends Report {
  lowPriority: number;
  nocategory: number;
  other: number;
  role: SyndicateRole;
}

export interface ManagersRetailReportWithTotals extends ManagerRetailReport {
  nocategoryTotal: number;
  lowPriorityTotal: number;
  otherTotal: number;
}

export class ManagerOverviewReportWithDefaultData
  implements ManagerOverviewReport {
  retailAmount = 0;
  stockAmount = 0;
  institutionalAmount = 0;
  amount = 0;
  total = 0;
  managerType = undefined;

  constructor(
    public id: number = -1,
    public name: string = '',
    public role?: SyndicateRole
  ) {}

  public sum(next) {
    this.retailAmount += next.retailAmount;
    this.stockAmount += next.stockAmount;
    this.institutionalAmount += next.institutionalAmount;
    this.total += next.total;

    return this;
  }
}
